import React, {useMemo} from 'react'
import {T} from '@colonist/ui'
import {getSeasonTiming, getSeasonTimingText} from './utils.ts'
import styles from './ProgressDate.module.scss'
import clsx from 'clsx'

export interface ProgressDateProps {
    className?: string
    seasonTimeRemaining: number | undefined
}

export const ProgressDate = ({
    className,
    seasonTimeRemaining,
}: ProgressDateProps) => {
    const seasonTimingText = useMemo(() => {
        if(seasonTimeRemaining == undefined) return '???'
        const seasonTiming = getSeasonTiming(seasonTimeRemaining)
        return getSeasonTimingText(seasonTiming)
    }, [seasonTimeRemaining])

    return <div className={clsx(styles.progressDateContainer, className)}>
        <T id='strings:leaderboardPage.seasonEndsIn' /> <b>{seasonTimingText}</b>
    </div>
}
